import * as React from "react";
import { css } from "@emotion/core";
import { Tag, ButtonGroup, Button } from "@blueprintjs/core";
import { CheckEditAccess, CheckViewAccess } from "context/";
import {
  useDrawingState,
  useDrawingActions,
  useSinkState,
  useMapActions,
  useMapState,
  mapStyles,
} from "context/";
import { formatWGS84 } from "utils";

const MapOverlay = ({ subscribeToCoordinates, zoom }) => {
  const { selectedSurveyId } = useSinkState();

  const { mode } = useDrawingState();
  const { setMode } = useDrawingActions();
  const { setSelectedStyle } = useMapActions();
  const { selectedStyle } = useMapState();

  return (
    selectedSurveyId && (
      <main>
        <section
          css={css`
            position: absolute;
            top: 10px;
            left: 10px;
          `}
        >
          <ButtonGroup vertical>
            <Button
              icon="hand-up"
              intent={mode === "select" ? "primary" : "none"}
              onClick={() => setMode("select")}
            />
            <CheckViewAccess fallback={null}>
              <Button
                icon="map-marker"
                intent={mode === "marker" ? "primary" : "none"}
                onClick={() => setMode("marker")}
              />
              <Button
                icon="layout-linear"
                intent={mode === "linestring" ? "primary" : "none"}
                onClick={() => setMode("linestring")}
              />
              <Button
                icon="polygon-filter"
                intent={mode === "polygon" ? "primary" : "none"}
                onClick={() => setMode("polygon")}
              />
            </CheckViewAccess>
          </ButtonGroup>
        </section>
        <section
          css={css`
            position: absolute;
            right: 10px;
            top: 10px;
          `}
        >
          <ButtonGroup>
            {mapStyles.map(([style]) => (
              <Button
                key={style}
                intent={selectedStyle === style ? "primary" : "none"}
                onClick={() => setSelectedStyle(style)}
              >
                {style}
              </Button>
            ))}
          </ButtonGroup>
        </section>
        <section
          css={css`
            position: absolute;
            left: 120px;
            bottom: 10px;
            display: flex;
          `}
        >
          <Coordinates subscribeToCoordinates={subscribeToCoordinates} />
          <Tag size="large">Map Zoom: {zoom}</Tag>
        </section>
      </main>
    )
  );
};

const Coordinates = ({ subscribeToCoordinates }) => {
  const [coords, setCoords] = React.useState({ latitude: 0, longitude: 0 });

  React.useEffect(() => {
    const subscription = subscribeToCoordinates(setCoords);
    return () => subscription.destroy();
  }, [subscribeToCoordinates]);

  const { latitude, longitude } = formatWGS84(coords);

  return (
    <Tag
      css={css`
        margin-right: 10px;
        font-variant-numeric: tabular-nums;
      `}
      size="large"
    >
      {`Cursor Coordinates (WGS84-EPSG:4326): ${latitude}, ${longitude}`}
    </Tag>
  );
};

export default MapOverlay;
